"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ui_1 = require("@vidazoo/ui");
var _ = require("lodash");
var moment = require("moment");
var theme = require("../../../../styles/baseTable.scss");
var AdsTxtRow = /** @class */ (function (_super) {
    tslib_1.__extends(AdsTxtRow, _super);
    function AdsTxtRow(props, context) {
        return _super.call(this, props, context) || this;
    }
    AdsTxtRow.prototype.render = function () {
        var _a = this.props, item = _a.item, type = _a.type;
        return (React.createElement("tr", null,
            React.createElement(ui_1.TableCell, null,
                React.createElement("div", { className: theme.name },
                    item.error ? React.createElement("div", { className: theme.errorIcon },
                        React.createElement(ui_1.Icon, { iconName: "icon-cancel-small", size: 2, iconColor: "red" })) : null,
                    (type === "website") ? item.domain : item.bundleId)),
            React.createElement(ui_1.TableCell, null, item.dateUpdated ? moment(Number(item.dateUpdated)).format("MMMM Do YYYY, h:mm:ss a") : React.createElement("div", { className: theme.na }, "N/A")),
            _.map(item, function (value, key) {
                return (_.includes(["domain", "bundleId", "dateUpdated", "error", "totalRequest"], key) ? null :
                    React.createElement(ui_1.TableCell, { key: key }, item[key] ? React.createElement("div", { className: theme.accountType }, item[key]) : React.createElement(ui_1.Icon, { iconName: "icon-cancel-small", size: 2, iconColor: "red" })));
            })));
    };
    AdsTxtRow.defaultProps = {};
    return AdsTxtRow;
}(React.Component));
exports.default = AdsTxtRow;
